import client from '../http_client';
import { DirectoryContents } from './types';

const root = '/v1/files';

/**
 * Service for interacting with the file server API
 */
export class FileService {
  /**
   * Fetch the contents of a directory
   */
  public static async browseDirectory(normalizedPath: string): Promise<DirectoryContents> {
    const params = new URLSearchParams({
      path: normalizedPath,
    });
    const response = await client.get<DirectoryContents>(`${root}/browse?${params}`);
    return response.data;
  }
}
